import PropTypes from "prop-types";
import { memo } from "react";
import Skeleton from "react-loading-skeleton";
import "./TripAdvisorSkeleton.scss";

const SKELETON_HIGHLIGHT_COLOR = "#cdcdcd";

const TripAdvisorSkeleton = ({ height = 12, borderRadius = 17 }) => {
	return (
		<div className="trip-advisor-skeleton__container">
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={18}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={12}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={12}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={12}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={12}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={12}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={58}
				containerClassName="trip-advisor-skeleton__node"
			/>
			<Skeleton
				highlightColor={SKELETON_HIGHLIGHT_COLOR}
				height={height}
				borderRadius={borderRadius}
				width={12}
				containerClassName="trip-advisor-skeleton__node"
			/>
		</div>
	);
};

TripAdvisorSkeleton.propTypes = {
	height: PropTypes.number,
	borderRadius: PropTypes.number,
};

export default memo(TripAdvisorSkeleton);
